<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <loader-barchart
                v-if="isLoading"
                class="graph-overlay"
                style="height: 430px; margin: 1em 0 2em 10px;"
                :styles="'height: 400px'"
            />
            <div
                id="new-patients-chart"
                style="height: 400px; margin: 3em 0 2em 10px;"
            ></div>

            <QTable
                :columns="patientHeader"
                :data="summaryData"
                :rows-per-page-options="[0]"
                hide-bottom
                class="q-table"
                :visible-columns="visibleColumns"
            >
                <template v-if="summaryData.length == 0" v-slot:bottom-row>
                    <q-tr>
                        <q-td colspan="10" align="center"
                            >No records available.</q-td
                        >
                    </q-tr>
                </template>
                <template v-else v-slot:body-cell-name="{ row }">
                    <td class="text-nowrap">
                        <patient-name
                            v-if="row.isActiveInBusinessPatient == 1"
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :openNew="true"
                            :patient="{
                                name: row.name,
                                encoded_id: row.encoded_id
                            }"
                        />
                        <span v-else>
                            {{ row.name }}
                        </span>
                    </td>
                </template>
                <template v-slot:body-cell-homeLocation="props">
                    <q-td :props="props" class="">
                        <span v-if="props.row.primary_owner_id">
                            {{ props.row.homeLocation }}
                        </span>
                    </q-td>
                </template>
            </QTable>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot.tooltip";
import "@/jquery/jquery.flot.axislabels";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import { forEach, findIndex } from "lodash";
import { QTable } from "quasar";
import PatientName from "../commons/patient-name.vue";

export default {
    mixins: [Report],
    components: {
        PatientName,
        QTable,
        LoaderBarchart: () => import("@/components/elements/loader-barchart"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("month"),
                    datePickerOptions: {
                        format: this.datepickerMonthFormat
                    }
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            dateRange: "",
            title: "New Patients",
            options: {},
            summaryData: [],
            isRecordSharing: false,
            patientHeader: [
                {
                    name: "name",
                    label: "Name",
                    field: "name",
                    align: "left",
                    style: "white-space: nowrap; min-width: 122px"
                },
                {
                    name: "Species",
                    label: "Species",
                    field: "species",
                    align: "left",
                    style: "white-space: nowrap; min-width: 122px"
                },
                {
                    name: "Breed",
                    label: "Breed",
                    field: "breed",
                    align: "left",
                    style: "white-space: nowrap; min-width: 143px"
                },
                {
                    name: "sex",
                    label: "Sex",
                    field: "sex",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "age",
                    label: "Age",
                    field: "age",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "birthdate",
                    label: "Birthdate",
                    field: "birthdate",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "color",
                    label: "Color",
                    field: "color",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "chip",
                    label: "Chip",
                    field: "chip",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "primary_owner",
                    label: "Primary Owner",
                    field: "primary_owner",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "added",
                    label: "Added",
                    field: "added",
                    align: "left",
                    style: "white-space: nowrap; min-width: 113px"
                },
                {
                    name: "homeLocation",
                    label: "Home Location",
                    field: "homeLocation",
                    align: "left",
                    style: "min-width: 150px;width: 8%",
                    classes: "text-capitalize"
                }
            ]
        };
    },
    async mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.exportOptionCsvOnly = true;
        self.data.datePickerOptions.format = self.datepickerMonthFormat;
        self.data.isFilterDateMonthOnly = true;
        self.data.datePickerOptionDefault = 1;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("month");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", this.init);
    },
    beforeDestroy: function () {
        this.data.datePickerOptions.format = this.getDateFormat();
        this.data.isFilterDateMonthOnly = false;
        this.data.datePickerOptionDefault = null;
        this.data.exportOptionCsvOnly = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    computed: {
        visibleColumns() {
            let self = this;
            let cols = self.patientHeader.map(e => e.field);
            const index = findIndex(
                cols,
                column => column.field === "homeLocation"
            );

            if (!self.isRecordSharing) {
                cols.splice(index, 1);
            }
            return cols;
        }
    },
    methods: {
        async init(params) {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            self.summaryData = [];
            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
            }
            self.dateRange = self.getDateRange(
                self.data.from,
                self.data.to,
                self.formatInMonth
            );
            await ReportService.getReport(CREPORT.TYPE.NEW_PATIENTS, {
                from: self.data.from,
                to: self.data.to
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.dynamicPageTitle(self.title);
                        self.renderGraph(res.resource.results);
                        self.renderList(res.resource.results);
                        self.dateRange = self.getDateRange(
                            res.resource.meta.from,
                            res.resource.meta.to,
                            self.formatInMonth
                        );
                        self.isRecordSharing = res.resource.isRecordSharing;
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self.isLoading = false;
                    self.isError = true;
                    self.renderGraph([{ date: "Month", total: 0 }]);
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        renderGraph(results) {
            let self = this;
            let xaxis = [];
            let xaxisLabel = [];

            let index = 1;
            forEach(results, result => {
                xaxisLabel.push([index, result.date]);
                xaxis.push([index, result.total]);
                ++index;
            });

            let data = [
                {
                    label: "New Patients",
                    data: xaxis
                }
            ];

            self.options = {
                series: {
                    lines: {
                        show: true,
                        fill: true,
                        align: "center",
                        barWidth: 0.9
                    },
                    points: { show: true }
                },
                grid: {
                    borderWidth: 0,
                    hoverable: true
                },
                xaxis: {
                    ticks: xaxisLabel
                },
                yaxis: {
                    min: 0,
                    tickSize: 10,
                    tickDecimals: 0,
                    tickFormatter: function numberWithCommas(x) {
                        return x
                            .toString()
                            .replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
                    }
                },
                tooltip: true,
                tooltipOpts: {
                    content: "%y.4",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                }
            };
            $.plot($("#new-patients-chart"), data, self.options);
            $(window).resize(function () {
                if (
                    self.$router.history.current.path ==
                    "/report/" + CREPORT.TYPE.NEW_PATIENTS
                ) {
                    $.plot($("#new-patients-chart"), data, self.options);
                }
            });
        },
        renderList(results) {
            forEach(results, result => {
                if (result.total > 0) {
                    forEach(result.patients, patient => {
                        this.summaryData.push(patient);
                    });
                }
            });
        }
    }
};
</script>
<style scoped>
.axisLabels {
    top: -20px;
    margin-right: -17px;
    color: #5d5d5d;
    font-size: 11px;
}

.q-table th {
    background: #000 !important;
    color: #fff !important;
    font-weight: bold !important;
}
</style>
